
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class OrderDetailedReportDialog extends Serenity.EntityDialog<OrderDetailedReportRow, any> {
        protected getFormKey() { return OrderDetailedReportForm.formKey; }
        protected getIdProperty() { return OrderDetailedReportRow.idProperty; }
        protected getLocalTextPrefix() { return OrderDetailedReportRow.localTextPrefix; }
        protected getNameProperty() { return OrderDetailedReportRow.nameProperty; }
        protected getService() { return OrderDetailedReportService.baseUrl; }
        protected getDeletePermission() { return OrderDetailedReportRow.deletePermission; }
        protected getInsertPermission() { return OrderDetailedReportRow.insertPermission; }
        protected getUpdatePermission() { return OrderDetailedReportRow.updatePermission; }

        protected form = new OrderDetailedReportForm(this.idPrefix);

    }
}